import {ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output} from "@angular/core";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-tab",
    styleUrls: ["./tab.component.scss"],
    templateUrl: "./tab.component.html"
})
export class FUITabComponent {
    @Output() public active$: EventEmitter<FUITabComponent>;
    @HostBinding("class.isActive") public isActive: boolean;
    @Input() public title: string;

    constructor() {
        this.active$ = new EventEmitter<FUITabComponent>();
        this.isActive = false;
    }

    /**
     * Set the current tab to active
     */
    setActive(state: boolean): void {
        this.isActive = state;
        this.active$.emit(this);
    }
}
